import { defineStore } from "pinia";
export const myFavoriteAdvertiserCollectionStore = defineStore(
  "my-favorite-advertiser-collection-store",
  {
    state: () => ({
      isLoading: false,
      errorMessage: "",
      isLoved: false,
    }),
    actions: {
      addAdvertiserToFavorites(advertiserOrgId) {
        this.isLoading = true;

        this.apiPost(
          `/my-favorite-advertiser-collection/${advertiserOrgId}/add-item`,
          {},
          () => {
            this.isLoved = true;
          },
          () => {
            this.errorMessage = "Failed to add this advertiser to your brands";
          },
          () => {
            this.isLoading = false;
          },
        );
      },
      removeAdvertiserFromFavorites(advertiserOrgId) {
        this.isLoading = true;

        this.apiPost(
          `/my-favorite-advertiser-collection/${advertiserOrgId}/remove-item`,
          {},
          () => {
            this.isLoved = false;
          },
          () => {
            this.errorMessage =
              "Failed to remove this advertiser from your brands.";
          },
          () => {
            this.isLoading = false;
          },
        );
      },
      isAdvertiserLoved(advertiserOrgId) {
        this.isLoading = true;

        this.apiGet(
          `/my-favorite-advertiser-collection/${advertiserOrgId}/is-loved`,
          {},
          response => {
            this.isLoved = response.is_loved;
          },
          () => {
            this.errorMessage =
              "Failed to check if advertiser is in your favorites";
          },
          () => {
            this.isLoading = false;
          },
        );

        return this.isLoved;
      },
    },
  },
);
